
    import '/mnt/src/components/DateRangePicker/index.md?watch=parent';
    export const demoIndex = {
  ids: ["daterangepicker-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/DateRangePicker/index.md?type=demo')
};